import tw from 'tailwind-styled-components'

export const CampaignUserListContainer = tw.div`
    flex
    gap-8
    p-4
`
